"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Immutably removes a key from an object
 * 
 * @category Object
 * @param {object} obj - The object on which to operate
 * @param {string} key - The key to remove
 * @returns {object}
 * @example
 * let obj = { hello: 'world', hi: 'earth' };
 * obj = removeKey(obj, 'hi')   // returns { hello: 'world' }
 */
var _default = function _default(obj, key) {
  return Object.keys(obj).reduce(function (o, k) {
    return k !== key ? _objectSpread(_objectSpread({}, o), {}, _defineProperty({}, k, obj[k])) : o;
  }, {});
};

exports.default = _default;